import { forwardRef } from 'react';
import cx from 'classnames';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import cn from './Flow.css.json';
import './Flow.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Flow = /*#__PURE__*/forwardRef(function Flow(props, ref) {
  const {
    className,
    style,
    wrap,
    spacing,
    orientation,
    testId,
    ...restProps
  } = props;
  const dt = useDesignTokens();
  const size = spacing ?? 'm';
  const orientationProps = orientation ?? 'horizontal';
  const styleTokens = renderInlineCssVars({
    'gap-size': dt.spacing.core[size]
  }, 'flow');
  return /*#__PURE__*/_jsx("div", {
    "data-testid": testId,
    ...restProps,
    ref: ref,
    className: cx(wrap && cn.wrap, cn.flow[orientationProps], className),
    style: {
      ...styleTokens,
      ...style
    },
    children: props.children
  });
});
//# sourceMappingURL=Flow.js.map